// @ts-nocheck
import * as React from "react";
import {inject, observer} from "mobx-react";
import {ExtTaskData} from "../../../../cuba/entities/base/tsadv_ExtTaskData";
import {observable} from "mobx";
import {injectMainStore, MainStoreInjected} from "@cuba-platform/react";
import {injectIntl, WrappedComponentProps} from "react-intl";
import TaskDataTable from "./TaskDataTable";
import CollapsibleCard from "../../../common/card-collapse";
import HistoryApproverTable from "../../../common/table/history-approver-table";

type TaskProps = {
  tasks: ExtTaskData[];
  isDep?: boolean;
  customTitle?: string;
};

@inject("rootStore")
@injectMainStore
@observer
class ExtTaskDataCards extends React.Component<TaskProps & MainStoreInjected & WrappedComponentProps> {

  state = {visible: false};

  @observable
  mainStore = this.props.mainStore!;

  render() {
    return (
      <CollapsibleCard
        title={this.props.intl.formatMessage({id: this.props.customTitle || "bproc.participants"})}
        cardProps={{
          className: "narrow-layout card-actions-container",
          bordered: false,
        }}
        panelKey="card-bpm"
      >
        {
          this.props.isDep
            ? <HistoryApproverTable key={'TaskDataTable'} data={this.props.tasks}/>
            : <TaskDataTable key={'TaskDataTable'} tasks={this.props.tasks}/>
        }

      </CollapsibleCard>
    )
  }
}

export default injectIntl(ExtTaskDataCards);
